import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import animation from "../../../../Animation/social media.json";

import { Menu } from "../../../../Context/MenuOpen/MenuContext";
import Lottie from "react-lottie";
const DigitalMarketingTab = () => {
  const {t , i18n} = useTranslation()
  const lottieContainerRef = useRef(null);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const [playLottie, setPlayLottie] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  gsap.registerPlugin(ScrollTrigger);
  useGSAP(() => {
  
    ScrollTrigger.create({
      trigger: lottieContainerRef.current,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      onEnter: () => setPlayLottie(true),
    });
  });
  return (
    <div className="WebDevelopment">
      <div className="svg">
        <div className="flex flex-col items-start">
          <h4>{t("BESPOKE SOLUTION")}</h4>
          <h5>{t("Digital Marketing services")}</h5>
          <div ref={lottieContainerRef} className="w-[80vw] md:w-[35vw] mt-[5vh]">
          {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
          </div>
        </div>
      </div>
      <div className="content">
        <p>{t("digital marketing isn’t just about posting it’s about planning, building, and optimizing campaigns that actually move people. We balance numbers with narrative, turning strategy into execution that looks great and performs. Whether you're launching a product, building brand awareness, or driving conversions, we handle the full journey start to scale.")}

        </p>
        <ul>
          <li>
          {t("We manage social media platforms with consistent visuals, tone, and smart content.")}
          </li>
          <li>
          {t("We run paid ad campaigns across Meta, Google, TikTok, and more with measurable results.")}
          </li>
          <li>
          {t("We activate influencer partnerships that resonate with your audience and drive real engagement.")}
          </li>
          <li>
        {t("We handle media buying using data, targeting, and budget efficiency not guesswork.")}
          </li>
          <li>
          {t("We write sharp, on-brand content and build cohesive visual identities that carry across every channel.")}
          </li>
        </ul>
        <Link className="btn-hover" to="/digital-marketing">
          <span>{t("Digital Marketing")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <g fill="none" fill-rule="evenodd">
                <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                <path
                  fill="currentColor"
                  d="M16.023 4.503c1.83-.126 3.244.942 4.185 2.174c.948 1.243 1.601 2.866 1.96 4.462c.357 1.596.453 3.311.156 4.773c-.285 1.404-1.046 3.01-2.767 3.525c-1.62.484-3.04-.22-4.052-1.072c-1.016-.855-1.876-2.053-2.552-3.176a25 25 0 0 1-.89-1.616a25 25 0 0 1-.889 1.615c-.676 1.124-1.536 2.322-2.552 3.177c-1.013.852-2.432 1.556-4.052 1.072c-1.721-.515-2.482-2.12-2.767-3.525c-.296-1.462-.2-3.177.157-4.773c.358-1.596 1.011-3.22 1.96-4.462c.94-1.232 2.354-2.3 4.184-2.174c1.716.12 2.963 1.283 3.74 2.269l.22.289l.219-.29c.777-.985 2.024-2.149 3.74-2.268M7.896 7.496c-.42-.029-.97.186-1.592 1.002c-.614.805-1.124 1.993-1.417 3.298s-.335 2.579-.144 3.52c.165.81.43 1.101.592 1.203l.068.034l.027.01c.232.07.614.05 1.26-.494c.645-.542 1.303-1.413 1.914-2.427c.272-.453.525-.917.752-1.363l.26-.525l.233-.497l.206-.458l.175-.407l.143-.346a9 9 0 0 0-.663-1.119c-.644-.916-1.29-1.394-1.814-1.43Zm8.335 0c-.524.037-1.17.515-1.814 1.431a9 9 0 0 0-.663 1.119l.227.543l.19.434l.107.234l.234.497l.26.525c.227.446.479.91.751 1.363c.611 1.014 1.27 1.885 1.913 2.427c.601.506.973.558 1.21.507l.052-.013c.13-.04.483-.249.686-1.248c.19-.94.149-2.214-.144-3.52c-.292-1.304-.802-2.492-1.417-3.297c-.623-.816-1.172-1.03-1.592-1.002"
                />
              </g>
            </svg>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default DigitalMarketingTab;
